<template>
    <div class="float-left mr-1">
        <span class="text-primary">
            <i
                class="fa fa-edit fa-lg icon-button"
                title="Atualizar Parcelamento"
                @click.stop="abrirModal()"
            ></i>
        </span>
		<b-modal
			v-model="showModal"
			id="modalInserirParcelamento"
			hide-footer
		>
			<div slot="modal-title">
				Parcelamento -
				<b-badge variant="warning">Atualizar</b-badge>
			</div>
			<parcelamento-form
				tipoOperacao="a"
				:investimento="investimento"
                :parcelamento="parcelamento"
				:showModal="showModal"
				@modalFechado="showModal = false"
				@obterParcelamentosAtualizados="$emit('obterParcelamentosAtualizados')"
			></parcelamento-form>
		</b-modal>
    </div>
</template>

<script>
import ParcelamentoForm from './ParcelamentoForm'

export default {
	components: {
		ParcelamentoForm
	},

	props: {
        investimento: {
			type: Object,
			default: () => ({})
		},

        parcelamento: {
			type: Object,
			default: () => ({})
		},
	},

	data() {
		return {
			showModal: false
		}
	},

	methods: {
		abrirModal() {
			this.showModal = true
		}
	},

	created() {},

	computed: {},

	watch: {},

	validations: {}
}
</script>
